import React from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {change, Field} from 'redux-form';
import {InputFieldWithValidation} from '../../../../../common/InputFieldWithValidation';
import InputSelectFieldWithValidation from '../../../../../common/InputSelectFieldWithValidation';
import BorderRadius from '../../../../../common/styled/BorderRadius';
import formMessages from '../../../../../../intl/afterSales/formMessages';
import {
    FORM_FIELD_DEALER_NO,
    FORM_FIELD_MAINTENANCE_PRIORITY,
    FORM_FIELD_REQUESTOR_NAME,
    FORM_LABEL_DEALER_ID_NAME,
    FORM_LABEL_MAINTENANCE_PRIORITY,
    FORM_LABEL_REQUESTOR_NAME,
} from '../../../../../../constants/formConstants';
import {priorityTreatment} from '../../../../../../constants/Utils';
import priorityTreatmentMessages from '../../../../../../intl/afterSales/priorityTreatmentMessages';
import SelectDealer from '../../../../../common/SelectDealer';
import {searchAseDealers} from '../../../../../../actions/ase/actionAseDealers';
import {required} from '../../../../../common/validationCommons';
import get from 'get-value';

const RequestorInformationMaintenanceSection = (props) => {
    const {
        form,
        formValues,
        readOnly,
        reqFields,
        searchAseDealers,
        dealerNumber,
        dealerName,
        changeDealerNumber,
        changeDealerName,
        userRights,
    } = props;
    // Only allow edit if explicitly permitted AND not readonly
    const canEditRequestDetail = userRights && userRights.canEditInternalTicketRequestDetail;
    const isFieldsDisabled = readOnly || !canEditRequestDetail;

    const handleDealerChange = (dealerData) => {
        changeDealerNumber(dealerData.dealerNumber);
        changeDealerName(dealerData.dealerName);
    };

    return (
        <>
            <h3 className="text-left ml-4">
                <FormattedMessage {...formMessages.REQUESTOR_INFORMATION_SECTION}/>
            </h3>
            <BorderRadius size={5} className="border border-secondary px-4 py-2 bg-white">
                <div className="form-row">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation
                            label={formMessages[FORM_LABEL_REQUESTOR_NAME]}
                            field={FORM_FIELD_REQUESTOR_NAME}
                            isSmall
                            isRequired={reqFields.includes(FORM_FIELD_REQUESTOR_NAME)}
                            isDisabled={true}
                        />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2">
                        <Field
                            name={FORM_FIELD_DEALER_NO}
                            component={SelectDealer}
                            label={formMessages[FORM_LABEL_DEALER_ID_NAME]} 
                            dealerNumber={dealerNumber}
                            dealerName={dealerName}
                            onDealerChange={handleDealerChange}
                            searchAseDealers={searchAseDealers}
                            isDisabled={isFieldsDisabled}
                            isRequired={reqFields.includes(FORM_FIELD_DEALER_NO)}
                            validate={reqFields.includes(FORM_FIELD_DEALER_NO) ? [required] : []}
                        />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2">
                        <InputSelectFieldWithValidation
                            label={formMessages[FORM_LABEL_MAINTENANCE_PRIORITY]}
                            field={FORM_FIELD_MAINTENANCE_PRIORITY}
                            options={priorityTreatment}
                            intlMessages={priorityTreatmentMessages}
                            isRequired={reqFields.includes(FORM_FIELD_MAINTENANCE_PRIORITY)}
                            isDisabled={isFieldsDisabled}
                        />
                    </div>
                </div>
            </BorderRadius>
        </>
    );
};

const mapStateToPropsComponent = (state, ownProps) => {
    const formName = ownProps.form || 'ASE_INTERNAL_MAINTENANCE_TICKET_FORM';
    return {
        dealerNumber: get(state, `form.${formName}.values.ticketSection.dealerNumber`),
        dealerName: get(state, `form.${formName}.values.ticketSection.dealerName`),
        formValues: get(state, `form.${formName}.values`, {}),
    };
};

const mapDispatchToPropsComponent = (dispatch, ownProps) => ({
    changeDealerNumber: (dealerNumber) => dispatch(change(ownProps.form || 'ASE_INTERNAL_MAINTENANCE_TICKET_FORM', 'ticketSection.dealerNumber', dealerNumber)),
    changeDealerName: (dealerName) => dispatch(change(ownProps.form || 'ASE_INTERNAL_MAINTENANCE_TICKET_FORM', 'ticketSection.dealerName', dealerName)),
    searchAseDealers: (searchTerm) => dispatch(searchAseDealers(searchTerm)),
});

export default connect(mapStateToPropsComponent, mapDispatchToPropsComponent)(RequestorInformationMaintenanceSection);
